import { css } from '@emotion/css';

export const resetLegacyLcBorderBox = css`
  [class^='lc-'],
  [class^='lc-']:after,
  [class^='lc-']:before {
    box-sizing: border-box;
  }
`;
